import { useState } from "react";

interface Props {
  /** What is being removed, for the accessible name: "line 3", "B15". */
  what: string;
  onConfirm: () => void;
  disabled?: boolean;
}

/** A remove button that asks once before it acts. The × on a quotation line
 * and on a bill line used to delete on the first click (Fix #16); a line
 * removed by a slip is a line somebody has to key again from the PDF. The ask
 * is inline, beside the line it concerns, rather than a browser dialog that
 * hides the row being asked about. */
export default function ConfirmRemove({ what, onConfirm, disabled = false }: Props) {
  const [asking, setAsking] = useState(false);
  if (!asking) {
    return (
      <button
        type="button"
        className="row-button danger"
        aria-label={`Remove ${what}`}
        disabled={disabled}
        onClick={() => setAsking(true)}
      >
        &times;
      </button>
    );
  }
  return (
    <span className="cm-confirm" role="group" aria-label={`Remove ${what}?`}>
      <span className="cm-confirm-ask">Remove?</span>
      <button
        type="button"
        className="row-button danger"
        disabled={disabled}
        onClick={() => {
          setAsking(false);
          onConfirm();
        }}
      >
        Yes, remove
      </button>
      <button type="button" className="row-button" onClick={() => setAsking(false)}>
        Keep
      </button>
    </span>
  );
}
